import { render, staticRenderFns } from "./AccountOrderDetailsShipment.vue?vue&type=template&id=063e6203&"
import script from "./AccountOrderDetailsShipment.vue?vue&type=script&lang=js&"
export * from "./AccountOrderDetailsShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports